<div class="dropdown" [class.show]="shouldExpand" #wrapper>

  <button (click)="toggleDropdown()" [class.btn-outline-warning]="!shouldExpand" [class.btn-warning]="shouldExpand"
    class="btn dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown"
    [attr.aria-expanded]="shouldExpand">

    <span class="oi oi-star favorit-star"></span>

    {{'FAVORITES'|translate}}
  </button>

  <div class="dropdown-menu dropdown-menu-right" [class.show]="shouldExpand" aria-labelledby="dropdownMenuButton">
    <a class="dropdown-item"
      (click)="$event.stopPropagation(); saveSearchTerms()">{{'SAVE_AS_FAVORITE'|translate}}...</a>
    <div class="dropdown-divider"></div>

    <a *ngFor="let fst of favoriteSearchTerms" [class.selected]="fst.key === selectedKey" class="dropdown-item pr-0"
      aria-labelledby="dropdownMenuButton" (click)="applySearchTerms(fst.key, fst.record)">
      <span>{{fst.label}}</span> <span class="oi oi-x ctrl-delete border-left py-1 px-2"
        (click)="deleteSearchTerm(fst.key, fst.record); $event.stopPropagation()"></span>
    </a>
  </div>

</div>

<app-modal-dialog #searchTermsLabelPrompt title="{{'SAVE_AS_FAVORITE'|translate}}" cancelButton="{{'CLOSE'|translate}}"
  [body]="modalBodyPrompt" backdrop="static" (positive)="onConfirmSave()">
</app-modal-dialog>
<ng-template #modalBodyPrompt>
  <p>{{'SEARCH_TERMS_SAVE_TITLE'|translate}}</p>
  <div>
    <label for="favoriteLabelInput">{{'NAME'|translate}}:</label>
    <input [(ngModel)]="favoriteLabel" type="text" appModalDialogFocus autofocus id="favoriteLabelInput"
      class="form-control input">
  </div>
</ng-template>